var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalk = function SvgWalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "walk_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#walk_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57565C",
    d: "m7.326 22.75 2.867-14.273-2.377.95v3.314h-1.5V8.445l4.743-2.016q.35-.15.699-.18.348-.03.67.067.32.096.595.297t.465.522l.846 1.35a6.1 6.1 0 0 0 1.878 1.951q1.131.738 2.537.795v1.5q-1.712-.076-3.053-.869a7.8 7.8 0 0 1-2.306-2.09l-.77 3.825 2.13 2.134v7.02h-1.5v-6.183l-2.447-2.09-1.915 8.272zm6.173-17.403a1.78 1.78 0 0 1-1.307-.54 1.78 1.78 0 0 1-.54-1.307q0-.767.54-1.306.54-.54 1.307-.54.768 0 1.307.54.54.54.54 1.306 0 .768-.54 1.307-.54.54-1.307.54"
  }))));
};
export default SvgWalk;